import { api } from './_request';

 export const get = (data) => {
 	return (dispatch) => {
		dispatch({
			type: 'INVENTARIO_FISICO_LIST',
			payload: data
		});
 	}
 };

 export const save = (item, callback) => {
	return (dispatch) => {

		dispatch({ type: 'SAVE' });

		api().post('/inventarioFisico/register', item).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'SAVE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};

export const update = (item, callback) => {
	return (dispatch) => {

        
		dispatch({ type: 'SAVE' });

		api().post(`/inventarioFisico/update/${item.value}`, item)
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'UPDATE_SUCCESS',
					payload: response.data
				});
				console.log('almacen action----->', response.data);

				if(typeof callback === 'function') callback(response.data);
			}
			else
			{
				dispatch({ type: 'SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};


export const delete2 = (id,referencia_tabla) => {

	return(dispatch) => {
		dispatch({
			type : 'REFERENCIA_TABLA',
			payload : referencia_tabla,

		});
		api().delete(`/inventarioFisico/delete/${id}`)
		.then(function(response){
			if (response.status === 200) {
				dispatch({
					type: 'DELETE_SUCCES',
					payload: response.data
				})
			} else{
				dispatch({type : 'DELETE_FAILURE'})
			}
		})
	}
}

export const borrarData = () => {
	return(dispatch) => {
		dispatch({type : 'INVENTARIO_APLICADO'})
	}
}


// WEBPACK FOOTER //
// ./src/actions/inventarioFisico.js